import { AfterViewInit, Component, ElementRef, Renderer2, ViewChild } from '@angular/core';
import { COUNTRIES, CountryItem } from '@shared/components/phone-input/tt/tt';
import { UntypedFormControl, Validators } from '@angular/forms';

@Component({
  selector: 'app-tt',
  templateUrl: './tt.component.html',
  styleUrls: ['./tt.component.scss']
})
export class TtComponent implements AfterViewInit {
  @ViewChild('inputElement') input: ElementRef;
  @ViewChild('switcherElement') switcher: ElementRef;

  phoneControl = new UntypedFormControl(null, Validators.required);
  countryList: CountryItem[] = COUNTRIES;

  showModal: boolean;
  selectedCountry = COUNTRIES.find(p => p.co === 'ru');

  constructor(
    private render: Renderer2,
  ) { }

  ngAfterViewInit(): void {
    this.setPadding();
  }

  setCountry(country: CountryItem) {
    this.selectedCountry = country;
    this.showModal = !this.showModal;
    setTimeout(() => this.setPadding(), 0);
  }

  setPadding() {
    const marginRight = 16;
    const switcherWidth = this.switcher.nativeElement.clientWidth;
    this.render.setStyle(
      this.input.nativeElement,
      'padding-left',
      `${switcherWidth + marginRight}px`
    );
  }
}
